// extracted by mini-css-extract-plugin
export default {"checkBox":"checkbox_checkBox__rfzLH","checkMark":"checkbox_checkMark__4JkBn"};